export default __webpack_public_path__ + "static/media/getting_started_assignment.107dd96f.png";